import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppCategoriesAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		multiple
		label="Categories"
		placeholder="All Categories"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/category`}
		{...props}
	/>
}